import React, {useEffect, useState} from 'react'
import {useErrorHandling} from 'context/errorHandling'
import {fetchAllFerryServices, fetchFerryServicesOfContractor} from 'services'
import {ControlledSelectField} from 'components/Shared/ControlledSelectField'
import {useTranslation} from 'react-i18next'
import {fetchContractorsPage} from 'services/ContractorService'
import {ferryPassageValuesWithContractorSelected, ferryPassageValuesWithFerryServiceSelected} from './formValues'
import {useField} from 'formik'

export function ContractorAndFerryServiceSelectField({name, ...rest}) {
  const [ferryServices, setFerryServices] = useState([])
  const [contractors, setContractors] = useState([])
  const [, {value}, {setValue}] = useField(name)
  const contractorId = value.contractorId

  const {handleError} = useErrorHandling()
  const {t} = useTranslation()

  const handleContractorChange = contractorId => {
    const newValue = ferryPassageValuesWithContractorSelected(contractorId)
    setValue(newValue)
  }

  const handleFerryServiceChange = (_, ferryService) => {
    const newValue = ferryPassageValuesWithFerryServiceSelected(value, ferryService)
    setValue(newValue)
  }

  useEffect(() => {
    if (ferryServices) {
      fetchContractorsPage({
        page: 0,
        sort: [],
        filters: [{key: 'id', value: ferryServices.map(service => service.contractorId)},
          {key: 'hasFerryService', value: true}],
        rowsPerPage:1000
      })
        .then(contractors => setContractors(contractors.items))
        .catch(handleError)
    }
  }, [handleError, ferryServices])


  useEffect(() => {
    if (contractorId) {
      fetchFerryServicesOfContractor(contractorId)
        .then(setFerryServices)
        .catch(handleError)
    } else {
      fetchAllFerryServices()
        .then(setFerryServices)
        .catch(handleError)
    }
  }, [contractorId, handleError])

  const formatFerryServiceLabel = service => {
    const contractor = contractors.find(contractor => contractor.id === service.contractorId)
    return `${service.startLocation.text} - ${service.endLocation.text}, ${contractor?.shortName}, ${service.type}`
  }

  return contractors.length > 0 && ferryServices.length > 0 && (<>
    <ControlledSelectField
      fieldName={`${name}.contractorId`}
      label={t('form.order.cargo.ferryPassage.contractor')}
      getOptionLabel={contractor => contractor.shortName}
      getOptionValue={contractor => contractor.id}
      options={contractors}
      onChange={handleContractorChange}
      required
      {...rest}
    />
    <ControlledSelectField
      fieldName={`${name}.ferryServiceId`}
      label={t('form.order.cargo.ferryPassage.ferryService')}
      options={ferryServices}
      getOptionValue={f => f.id}
      getOptionLabel={formatFerryServiceLabel}
      onChange={handleFerryServiceChange}
      required
      {...rest}
    />
  </>)

}

